import { history, useLocation } from '@umijs/max';
import type React from 'react';

const stripTrailingSlashes = (value: string) => {
  let end = value.length;
  while (end > 0 && value[end - 1] === '/') end -= 1;
  return value.slice(0, end);
};

const isFilesPath = (pathname: string) => {
  const normalizedPath = stripTrailingSlashes(pathname);
  return normalizedPath === '/files' || normalizedPath.startsWith('/files/');
};

const isFilesMenuClick = (target: HTMLElement | null) => {
  const filesLink = target?.closest('a[href^="/files"], a[href*="/files"]');
  const menuItem = target?.closest('[data-menu-id]');
  const menuId = menuItem?.getAttribute('data-menu-id') ?? '';
  return Boolean(filesLink || menuId.includes('/files'));
};

const FilesSidebarResetBoundary = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isFilesPath(location.pathname)) return;
    if (!isFilesMenuClick(event.target as HTMLElement | null)) return;

    event.preventDefault();
    event.stopPropagation();
    history.push(`/files?root=personal&reset=${Date.now()}`);
  };

  return (
    <div onClickCapture={handleClickCapture} style={{ height: '100%', minHeight: 0 }}>
      {children}
    </div>
  );
};

export default FilesSidebarResetBoundary;
